<template>
	<div>
		<core-select-internals
			:value="computedValue"
			@input="onInput"
			:prefetch="true"
		/>
		<div v-if="isLoading" class="mt1">Updating...</div>

		<!-- <pre>
			{{ computedStakeholders }}
		</pre
		> -->
	</div>
</template>

<script>
import CoreSelectInternals from "@/modules/core/components/CoreSelectInternals"
import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	components: { CoreSelectInternals },
	props: {
		value: {
			type: Array
		}
	},

	data() {
		return {
			isLoading: false
		}
	},

	computed: {
		computedStakeholders() {
			return this.$store.state.caseManagement?.case?.stakeholders || []
		},

		computedValue() {
			if (!this.computedStakeholders?.length) return []

			return this.computedStakeholders.map(item => ({
				value: item?.entity?.id,
				name: item?.entity?.name
			}))
		}
	},

	methods: {
		// Requirements is to allow only one stakeholder
		// so anytime they try to change a stakeholder, we remove all stakeholders
		// and then add new stakeholder
		async onInput(value) {
			this.isLoading = true
			// 1: Remove all stakeholders
			const removedStakeholders = await Promise.all([
				...this.computedStakeholders.map(item =>
					this.removeStakeholderFromCase(item?.id)
				)
			])

			// Check errors
			if (
				removedStakeholders.find(
					item => item.data.removeStakeholderFromCase.status !== "success"
				)
			) {
				this.$store.dispatch(
					"showError",
					"Something went wrong, please try again later"
				)
				this.isLoading = false
				return
			}

			// 2: Add stakeholder but only if value is not empty
			// if value is empty, we just refetch store and return
			// because user wanted to remove stakeholder altogether
			if (!value?.[0]?.id) {
				await this.refetchStore()
				this.isLoading = false
				return
			}

			const res = await this.addStakeholderToCase(value?.[0]?.id || "")

			// Check errors
			if (res?.data?.addStakeholderToCase?.status !== "success") {
				this.$store.dispatch(
					"showError",
					"Something went wrong, please try again later"
				)
				this.isLoading = false
				return
			}

			// Refetch store
			await this.refetchStore()

			this.isLoading = false
		},

		async refetchStore() {
			const res = await this.$store.dispatch("caseManagement/fetchCase", {
				caseId: this.$store.state.caseManagement.caseId
			})

			return Promise.resolve(res)
		},

		async addStakeholderToCase(entityId) {
			const query = gql`
				mutation addStakeholderToCase(
					$caseId: String!
					$input: addStakeholderInput!
				) {
					addStakeholderToCase(caseId: $caseId, input: $input) {
						status
						errors
					}
				}
			`

			const variables = {
				caseId: this.$store.state.caseManagement.caseId,
				input: {
					entityId,
					type: "underwriter"
				}
			}

			const res = await api({ query, variables })
			return Promise.resolve(res)
		},

		async removeStakeholderFromCase(stakeholderId) {
			const query = gql`
				mutation removeStakeholderFromCase(
					$caseId: String!
					$stakeholderId: String!
				) {
					removeStakeholderFromCase(
						caseId: $caseId
						stakeholderId: $stakeholderId
					) {
						errors
						status
					}
				}
			`

			const variables = {
				caseId: this.$store.state.caseManagement.caseId,
				stakeholderId
			}

			const res = await api({
				query,
				variables
			})

			return Promise.resolve(res)
		}
	}
}
</script>
